import "./DeleteModal.css";
import { MdWarningAmber } from "react-icons/md";

function DeleteModal({
  isOpen,
  title = "Delete Item",
  message = "Are you sure you want to delete this item?",
  loading = false,
  onCancel,
  onConfirm,
}) {
  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay">

      <div className="delete-modal">

        <div className="delete-icon">
          <MdWarningAmber />
        </div>

        <h2>{title}</h2>

        <p>{message}</p>

        <div className="delete-actions">

          <button
            className="cancel-btn"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className="delete-btn"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </button>

        </div>

      </div>

    </div>
  );
}

export default DeleteModal;